module.exports = __webpack_public_path__ + "env.f2aa7e1.basis";